import React, { Component } from "react";
import Form from "../components/Form/Form";
import templates from "../components/FormTemplates";
import actions from "../actions/reisadviezen";
import { connect } from "react-redux";
import scrollTo from "../utils/scrollTo";
import dynamicPortal from "../utils/dynamicPortal";
import connection from "../api/config/connection";

export class ReisadviezenPortal extends Component {
  constructor() {
    super();
    this.formRef = React.createRef();
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return dynamicPortal.load(".js-react-reisplanner", (config) => {
      config.submit.method = "GET";
      config.submit.async = true;
      return (
        <div className="theme--accent">
          <div className="container container--center container--clearfix">
            <div className="container container--margin">
              <Form
                ref={this.formRef}
                config={config}
                templates={templates}
                axios={connection.instance()}
                onSubmit={async (values) =>
                  await this.handleSubmit(values, config)
                }
                onSubmitted={async (response, values, prevTime, nextTime) =>
                  await this.handleSubmitted(
                    response,
                    values,
                    config,
                    prevTime,
                    nextTime
                  )
                }
                isTravelPlanner={true}
                onError={(error) => this.handleError(error)}
              />
            </div>
          </div>
        </div>
      );
    });
  }

  async handleSubmit(values, config) {
    values = Object.assign({}, values);
    config = Object.assign({}, config);

    this.props.requestReisadviezen(values, config);
    if (config.submit.flex) {
      config.submit.flex.forEach((flex) => {
        const flexConfig = Object.assign({}, config, {
          submit: Object.assign({}, config.submit, {
            action: flex.action,
            isRequired: flex.isRequired,
          }),
        });
        const flexValues = Object.assign({}, values, {
          flex: flex.type,
        });

        this.props.requestFlexReisadviezen(flexValues, flexConfig);
        Form.executeRequest(flexConfig, connection.instance(), flexValues)
          .then((response) =>
            this.handleFlexSubmitted(response, flexValues, flexConfig)
          )
          .catch((response) =>
            this.handleFlexError(response, flexValues, flexConfig)
          );
      });
    }
  }

  handleFlexSubmitted(response, flexValues, flexConfig) {
    this.props.receivedFlexReisadviezen(response, flexValues, flexConfig);
  }

  handleFlexError(response, flexValues, flexConfig) {
    this.props.failedFlexReisadviezen(response, flexValues, flexConfig);
  }

  handleError(error) {
    this.props.failedReisadviezen();
  }

  async handleSubmitted(response, values, config, prevTime, nextTime) {
    this.props.receivedReisadviezen(
      response,
      values,
      config,
      prevTime,
      nextTime,
      true
    );
    if (response.data && !response.data.error) return;

    let itineraries = [];
    try {
      itineraries = response.data.result.result.plan.itineraries || [];
    } catch (ex) {}

    const plans = itineraries.map(
      ({
        departureDelay,
        arrivalDelay,
        transfers,
        fare,
        legs,
        realtimeInfo = {},
        occupancy,
      }) => {
        const { cancellations, ludMessages = [] } =
          realtimeInfo === null ? {} : realtimeInfo;
        //Todo (24-2-2019): Retreive delays from itineraries for OTP and 9292

        //OTP (The data is not yet provided on itineraries level, only on legs level)
        let startTime = legs[0].startTime;
        let endTime = legs[legs.length - 1].endTime;
        let duration = endTime - startTime;

        let startTimeDelay = departureDelay;
        let endTimeDelay = arrivalDelay;
        //let durationDelay = (endTimeDelay || endTime) - endTime + ((startTimeDelay || startTime) - startTime);

        //9292
        // if(!startTimeDelay) {
        //   startTimeDelay = departureDelay //Convert from 9292 realtime
        // }
        // if(!endTimeDelay) {
        //   endTimeDelay = arrivalDelay //Convert from 9292 realtime
        // }

        const cancelled = cancellations === "Cancellations";

        let fareInfo = undefined;
        if (fare && fare.fare.regular) {
          fareInfo = {
            price: !fare.fare.regular.cents
              ? 0
              : fare.fare.regular.cents / 100.0,
            currency: !(
              fare.fare.regular.currency && fare.fare.regular.currency.currency
            )
              ? "EUR"
              : fare.fare.regular.currency.currency,
          };
        }

        return {
          duration,
          //durationDelay
          startTime,
          endTime,
          startTimeDelay,
          endTimeDelay,
          transfers,
          fare: fareInfo,
          legs,
          cancelled,
          ludMessages,
          texelhopperFlexLoading:
            config.submit.flex &&
            config.submit.flex.some((flex) => flex.type === "texelhopper"),
          occupancy,
        };
      }
    );

    let origin = "?";
    let destination = "?";
    let targetIsArrivalTime = false;
    let selectedDate = "?";
    try {
      if (values["arrive"]) targetIsArrivalTime = true;
      if (values["from"])
        origin = (
          typeof values["from"] === "string"
            ? JSON.parse(values["from"])
            : values["from"]
        ).description;
      if (values["date"]) selectedDate = values["date"];
      if (values["to"])
        destination = (
          typeof values["to"] === "string"
            ? JSON.parse(values["to"])
            : values["to"]
        ).description;
    } catch (ex) {}

    this.props.receivedReisadviezen(
      plans,
      origin,
      destination,
      selectedDate,
      targetIsArrivalTime
    );

    const resultsElement = document.querySelector(
      ".js-react-reisadviezen-flex, .js-react-reisadviezen"
    );
    if (resultsElement) scrollTo.scrollToElement(resultsElement, 0);
  }
}

export default connect(
  (state) => ({
    reisadviezen: state.reisadviezen,
  }),
  {
    requestReisadviezen: actions.request,
    receivedReisadviezen: actions.received,
    failedReisadviezen: actions.failed,
    requestFlexReisadviezen: actions.flexRequest,
    receivedFlexReisadviezen: actions.flexReceived,
    failedFlexReisadviezen: actions.flexFailed,
  }
)(ReisadviezenPortal);



// WEBPACK FOOTER //
// ./src/portals/ReisplannerPortal.js